import { Button, Checkbox, Dialog } from 'components/ui'
import React, { useState } from 'react'
import useResponsive from 'utils/hooks/useResponsive'
import ReactHtmlParser from 'html-react-parser'
import { Loading } from 'components/shared'

const FormFooter = ({
    subTotalAmount,
    totalAmount,
    isSubmitting,
    startingDate,
    termsOfUseContent,
}) => {
    const [agreeTerms, setAgreeTerms] = useState(false)
    const [reviewLicense, setReviewLicense] = useState(false)

    const { windowWidth } = useResponsive()

    const [dialogIsOpen, setIsOpen] = useState(false)

    const openDialog = () => {
        setIsOpen(true)
    }

    const onDialogClose = (e) => {
        console.log('onDialogClose', e)
        setIsOpen(false)
    }

    const onDialogOk = (e) => {
        console.log('onDialogOk', e)
        setIsOpen(false)
    }

    return (
        <>
            <div className="flex flex-col gap-4">
                <div className="flex justify-between items-center">
                    <span className="font-medium text-zinc-700">SubTotal</span>
                    <span className="font-medium text-zinc-700">
                        us ${subTotalAmount.toLocaleString()}
                    </span>
                </div>
                

                <div className="border-t-2 border-black"></div>
                <div className="flex justify-between items-start">
                    <span className="font-medium text-lg text-zinc-700">
                        Total Amount
                    </span>
                    <div className="flex flex-col items-end">
                        <span className="font-medium text-lg text-zinc-700">
                            US ${totalAmount.toLocaleString()} /mo
                        </span>
                        <span className="font-light text-sm text-black">
                            Starting on {startingDate}
                        </span>
                    </div>
                </div>
            </div>
            <div>
                <Button
                    loading={isSubmitting}
                    variant="solid"
                    block
                    disabled={!agreeTerms || !reviewLicense}
                >
                    Subscribe
                </Button>
                <div className="mt-4">
                    <div className="flex flex-col mb-5">
                        <div className="flex justify-start gap-1">
                            <Checkbox
                                className="mb-2 mx-0"
                                onChange={setAgreeTerms}
                            >
                                By ticking this box you agree to our
                            </Checkbox>
                            <span
                                className="text-secondary cursor-pointer underline"
                                onClick={() => openDialog()}
                            >
                                Terms of Use
                            </span>
                        </div>

                        <Checkbox onChange={setReviewLicense}>
                            By ticking this box you agree to review the Terms of
                            Use sent to your email after paying.
                        </Checkbox>
                    </div>
                </div>
            </div>

            <Dialog
                isOpen={dialogIsOpen}
                onClose={onDialogClose}
                onRequestClose={onDialogClose}
                overlayClassName="z-50"
                width={windowWidth / 2}
            >
                <div className="flex flex-col h-full justify-between">
                    <h5 className="mb-4">DISCO Terms of Use</h5>
                    <div className="max-h-96 overflow-y-auto">
                        <Loading loading={!termsOfUseContent} type="cover">
                            {ReactHtmlParser(termsOfUseContent)}
                        </Loading>
                    </div>
                    <div className="text-right mt-6">
                        <Button variant="solid" onClick={onDialogOk}>
                            Close
                        </Button>
                    </div>
                </div>
            </Dialog>
        </>
    )
}

export default FormFooter
